import { errorHandler, loadersSlice, notifyMessageCreator } from 'Modules'
import { get, without } from 'lodash'
import { call, put, takeEvery, select, takeLatest } from 'typed-redux-saga'
import { ResponseCatalog, FormErrorModel } from 'Models'
import {
	OptionModel,
	optionApi,
	OptionNS,
	optionSlice,
	surveySlice,
	surveySelector,
} from 'Pages/survey'

function* getOne(action: OptionNS.GetOne) {
	try {
		const res = yield* call(optionApi.getOne, action.payload)
		const current = new ResponseCatalog<OptionModel>()
		current.entries = [res]
		yield* put(optionSlice.actions.setOne(current))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* updateOne(action: OptionNS.UpdateOne) {
	try {
		const { survey_id, data, callback } = action.payload
		const res = yield* call(optionApi.updateOne, data)
		yield* put(surveySlice.actions.getOne(survey_id))
		callback?.(res)
	} catch (error) {
		const { errorCallback } = action.payload
		const errors = error?.data?.errors
		const isFileError = errors.some((o) => Object.keys(o)?.[0]?.includes('attachments'))
		if (isFileError) {
			errorCallback?.(Object.keys(errors?.[0] ?? {}).map((key) => errors[0][key]))
		} else {
			yield* call(errorHandler, error)
		}
		const reducedErr = get(error, 'data.errors', []).reduce((obj, item): FormErrorModel => {
			return { ...obj, ...item }
		}, {})
		yield* put(optionSlice.actions.setOptionFromError(reducedErr))
	}
}

function* deleteOne(action: OptionNS.DeleteOne) {
	try {
		const { callback, id } = action.payload
		yield* call(optionApi.deleteOne, id)
		yield* call(notifyMessageCreator, 'common.option_delete.success')
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* createOne(action: OptionNS.CreateOne) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { survey_id, question_id, data, callback } = action.payload
		const res = yield* call(optionApi.createOne, question_id, data)
		const chain = yield* select(surveySelector.getOptionSaveChain)
		// @ts-ignore TODO: NC-5191 - Fix types (chain is probably string[] instead op Option[])
		// TODO: (this saga is not called at all, maybe we should remove it)
		yield* put(optionSlice.actions.setSaveChain(without(chain, res.id)))
		yield* put(surveySlice.actions.getOne(survey_id))
		yield* put(loadersSlice.actions.hideGlobalLoader())
		callback?.()
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		const { errorCallback } = action.payload
		const errors = error?.data?.errors
		const isFileError = errors.some((o) => Object.keys(o)?.[0]?.includes('attachments'))
		if (isFileError) {
			errorCallback?.(Object.keys(errors?.[0] ?? {}).map((key) => errors[0][key]))
		} else {
			yield* call(errorHandler, error)
		}
		const reducedErr = get(error, 'data.errors', []).reduce((obj, item): FormErrorModel => {
			return { ...obj, ...item }
		}, {})
		yield* put(optionSlice.actions.setOptionFromError(reducedErr))
	}
}

export const optionSaga = function* saga() {
	yield* takeEvery(optionSlice.actions.getOne.type, getOne)
	yield* takeEvery(optionSlice.actions.updateOne.type, updateOne)
	yield* takeEvery(optionSlice.actions.deleteOne.type, deleteOne)
	yield* takeLatest(optionSlice.actions.createOne.type, createOne)
}
